// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

import {DateTime} from 'docs/markdoc/attribute-types';

export const CollectEmail: MarkdocTagRegistration = {
  tag: 'collect-email',
  component: 'CollectEmail',
  localize: true,
  attributes: {
    list: {
      type: String,
      required: true,
      description: 'Subscription list. Also sets the route to POST to.',
    },
    send_direct_email: {
      type: Boolean,
      required: false,
      description:
        'If true, "list" can be a @stripe.com email. This allows skipping setting up Marketo.',
    },
    form_email_tag_name: {
      type: String,
      description: 'Legacy: form email tag name',
    },
    form_email_placeholder: {
      type: String,
      description: 'Placeholder for email input',
      localizable: true,
    },
    intro_text: {
      type: String,
      description: 'Title text above the input',
      required: true,
      localizable: true,
    },
    body_text: {
      type: String,
      description: 'Subtitle text above the input',
      required: true,
      localizable: true,
    },
    form_cta_text: {
      type: String,
      description: 'Text on button to subscribe to email updates',
      required: false, // The default button text is 'Get updates'
      localizable: true,
    },
    show_email_confirmation: {
      type: Boolean,
      description:
        'Determine whether to show the confirmation email on success',
      required: false,
      default: true,
    },
    success_text: {
      type: String,
      description: 'Success text to show after email has been submitted',
      required: false, // The message 'You are now subscribed! will appear first, with optional success_text below it.
      localizable: true,
    },
    email_privacy_text: {
      type: Boolean,
      description:
        'Show unsubscribe message at the bottom of the email collection form',
    },
    until: {
      type: DateTime,
      description: 'Show the form until the specified date',
    },
  },
};
